import React from 'react';
import { centeredFull, defaultFont } from '../../styles/SharedStyles';
import { useIsOnline } from '../../hooks';

export interface OnlineProps {
  children?: any;
  reload?: () => any;
}

/** Wrapper component to show a message when there is no internet connection */
export function Online({ children, reload }: OnlineProps): JSX.Element {
  const online = useIsOnline();

  function handleReloadClick(): void {
    if (reload) {
      reload();
    } else {
      window.location.reload();
    }
  }

  if (online) {
    return children;
  }

  return (
    <span style={{ ...defaultFont, ...centeredFull }}>
      Please check your internet connection or&nbsp;
      <span
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={handleReloadClick}
      >
        reload this page
      </span>
      .
    </span>
  );
}
